import React from "react";
import { Helmet } from "react-helmet-async";

const SeoHelmet = ({
  title,
  description,
  keywords = [],
  url,
  image,
  lang = "en",
  author = "Salgosoft",
}) => {
  const keywordsStr = Array.isArray(keywords) ? keywords.join(", ") : keywords;

  return (
    <Helmet htmlAttributes={{ lang }}>
      {/* Basic Meta */}
      <title>"AI Inside Life"</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywordsStr} />
      <meta name="author" content={author} />
      <link rel="canonical" href={url} />
      <meta name="theme-color" content="#000000" />

      {/* Dublin Core */}
      <meta name="DC.title" content={title} />
      <meta name="DC.creator" content={author} />
      <meta name="DC.description" content={description} />
      <meta name="DC.publisher" content={author} />
      <meta name="DC.date" content={new Date().toISOString().split("T")[0]} />
      <meta name="DC.language" content={lang} />
      <meta name="DC.identifier" content={url} />
      <meta name="DC.rights" content={`© 2025 ${author}. All rights reserved.`} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={author} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
};

export default SeoHelmet;
